import React, { createContext, useContext, useState, useCallback } from 'react'
import { ErrorHandler } from 'src/helper/ErrorHandler' 

const AddErrorContext = createContext()

export const useAddErrorContext = () => useContext(AddErrorContext)

export const ErrorProvider = ({ children }) => {
  const [error, setError] = useState(null)

  const addError = useCallback((error, callback = () => {}) => {
    setError({ error, callback })
  }, [])

  const clearError = () => {
    setError(null)
  }

  return (
    <AddErrorContext.Provider value={addError}>
      {children}
      {error && (
        <ErrorHandler error={error.error} defaultErrorMessage={error.callback} onClose={clearError} />
      )}
    </AddErrorContext.Provider>
  )
}
